/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetAccessProfileQueryResponse, GetAccessProfileQueryParams, GetAccessProfile400, GetAccessProfile401, GetAccessProfile403, GetAccessProfile404, GetAccessProfile409, GetAccessProfile500 } from "../../types/authorizationController/GetAccessProfile.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getAccessProfile } from "../../client/authorizationController/getAccessProfile.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getAccessProfileQueryKey = (params: GetAccessProfileQueryParams) => [{ url: '/api/auth/profile/access' }, ...(params ? [params] : [])] as const

export type GetAccessProfileQueryKey = ReturnType<typeof getAccessProfileQueryKey>

export function getAccessProfileQueryOptions(params: GetAccessProfileQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getAccessProfileQueryKey(params)
        return queryOptions<GetAccessProfileQueryResponse, ResponseErrorConfig<GetAccessProfile400 | GetAccessProfile401 | GetAccessProfile403 | GetAccessProfile404 | GetAccessProfile409 | GetAccessProfile500>, GetAccessProfileQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return getAccessProfile(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get user access profile
 * {@link /api/auth/profile/access}
 */
export function useGetAccessProfile<TData = GetAccessProfileQueryResponse, TQueryData = GetAccessProfileQueryResponse, TQueryKey extends QueryKey = GetAccessProfileQueryKey>(params: GetAccessProfileQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetAccessProfileQueryResponse, ResponseErrorConfig<GetAccessProfile400 | GetAccessProfile401 | GetAccessProfile403 | GetAccessProfile404 | GetAccessProfile409 | GetAccessProfile500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getAccessProfileQueryKey(params)
         

         const query = useQuery({
          ...getAccessProfileQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetAccessProfile400 | GetAccessProfile401 | GetAccessProfile403 | GetAccessProfile404 | GetAccessProfile409 | GetAccessProfile500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}